import ModalPanel from '@admin/components/modal_panel'
import Message from '@admin/components/message'
import PropTypes from 'prop-types'
import React from 'react'

class Translating extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    network: PropTypes.object
  }

  static propTypes = {
    entity_type: PropTypes.string,
    entity_id: PropTypes.number,
    onDone: PropTypes.func
  }

  _handleDone = this._handleDone.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Message { ...this._getMessage() } />
      </ModalPanel>
    )
  }

  componentDidMount() {
    this._handleJoin()
  }

  componentWillUnmount() {
    this._handleLeave()
  }

  _handleJoin() {
    const { entity_type, entity_id} = this.props
    const { team } =  this.context.admin
    this.context.network.subscribe({ 
      channel: `/teams/${team.id}/admin/mjson/${entity_type}/${entity_id}/translate`,
      action: 'complete', 
      handler: this._handleDone
    })
  }

  _handleLeave() {
    const { entity_type, entity_id} = this.props
    const { team } =  this.context.admin
    this.context.network.unsubscribe({ 
      channel: `/teams/${team.id}/admin/mjson/${entity_type}/${entity_id}/translate`,
      action: 'complete', 
      handler: this._handleDone 
    })
  }

  _getMessage() {
    return {
      svg: 'refresh_cw',
      spinning: true,
      title: 't(Translating Content)',
      text: 't(Hang on while we translate your content)'
    }
  }

  _getPanel() {
    return {
      title: 't(Translate Content)'
    }
  }

  _handleDone() {
    this.props.onDone()
  }

}

export default Translating

